module.exports = __webpack_public_path__ + "img/T2B_xh_8.18bfc566.png";